import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgLeadershipIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.6 20v-1.0588c0-1.4825 0-2.2238-.2943-2.79-.2588-.4981-.6719-.903-1.1799-1.1568-.5776-.2885-1.3337-.2885-2.8458-.2885H7.32c-1.5121 0-2.2682 0-2.8458.2885-.508.2538-.921.6587-1.18 1.1568C3 16.7174 3 17.4587 3 18.9412V20M15.6 6.7647l1.8 1.7647L21 5m-8.55 3.0882c0 1.7056-1.4103 3.0883-3.15 3.0883S6.15 9.7938 6.15 8.0882 7.5603 5 9.3 5s3.15 1.3827 3.15 3.0882"
    />
  </svg>
);
export default SvgLeadershipIcon;
